import * as Yup from 'yup';

export const schema = () => {
  return Yup.object().shape({
    borrowerAcceptance: Yup.boolean().oneOf([true], 'Required'),
    guarantorAcceptance1: Yup.boolean().oneOf([true], 'Required'),
  });
};

export const multiGuarantorsSchema = () => {
  return Yup.object().shape({
    borrowerAcceptance: Yup.boolean().oneOf([true], 'Required'),
    guarantorAcceptance1: Yup.boolean().oneOf([true], 'Required'),
    guarantorAcceptance2: Yup.boolean().oneOf([true], 'Required'),
  });
};
